import axios from './http';
// let baseUrl = `http://172.16.10.21:10183/api`;
// let baseUrl = `http://192.168.10.70:85/api`;
function getArgs () {
  let args = {};
  let query = location.href.split("?")[1]
  if (query) {
    let pairs = query.split("&");
    pairs.forEach(item => {
      let key = item.split('=')[0]
      let value = item.split('=')[1]
      args[key] = value
    })
  }
  return args
}
let baseUrlWnq = "";
let baseUrl = "";
let QUERY_BASEURL = ""
let REGISTER_BASEURL = ""
let href = window.location.href
if (href.indexOf('m.hyzgapp') > -1) {
  baseUrl = `https://hyjy.hyzgapp.com/api`;
  QUERY_BASEURL = "https://hyjy-query.hyzgapp.com/api"
  REGISTER_BASEURL = "https://hyjy-register.hyzgapp.com/api"
} else {
  baseUrl = `https://hyjy-test.hyzgapp.com:8600/api`;
  // baseUrl = `http://172.16.10.59:10183/api`;
  
  QUERY_BASEURL = `https://hyjy-test.hyzgapp.com:8600/api`;
  REGISTER_BASEURL = "https://hyjy-test.hyzgapp.com:8600/api"
}
let   baseUrl1 = `https://hyjy.hyzgapp.com/api`; //生产环境配置
let   baseUrl2 = `https://hyjy-test.hyzgapp.com:8600/api`; //生产环境配置
// let   baseUrl1 = `https://hyjy-test.hyzgapp.com:8600/api`; //生产环境配置
// testApi
baseUrlWnq = "https://www.jxwnqwl.com/api"; //万年青的请求域名


export const getSignWnq = data => { return axios.get(`${baseUrlWnq}/wx/2/app/get/signature?url=` + data.url,) }; //万年青跳转app的配置
export const getOrderDetailsWnq = data => { return axios.post(`${baseUrlWnq}/tm/cargo/getCargoDetail`, data) }; //万年青扫描货源二维码跳转app
export const getSign = data => { return axios.get(`${baseUrl1}/wx/2/app/get/signature?url=` + data.url,) }; //交易跳转app的配置
export const getOrderDetails = data => { return axios.post(`${baseUrl1}/td/circuit/getOrderRecordAnon`, data) }; //交易扫描货源二维码跳转app


export const getDriverRadio = data => { return axios.post(`${baseUrl}/ts/finance/broadcast/getBroadcastByDriver`, data) };

export const getCargoRadio = data => { return axios.post(`${baseUrl}/ts/finance/broadcast/getBroadcastByShipper`, data) };

export const getOrderPages = data => { return axios.post(`${QUERY_BASEURL}/td/circuit/getDriverPtmOrders`, data) };
//车队地图列表
export const getFleetMapList = data => { return axios.post(`${QUERY_BASEURL}/cd/fleetWithUser/mapList`, data) };
//车队详情
export const fleetDetail = data => { return axios.post(`${QUERY_BASEURL}/cd/fleet/list`, data) }
//车队成员
export const getMember = data => { return axios.post(`${QUERY_BASEURL}/cd/fleetWithUser/list`, data) }

// 中国行用户省市区信息
export const getUserRegion = data => { return axios.post(`${REGISTER_BASEURL}/dlzg/lightenchina/mapList`, data) }
// 按省份分组点亮信息统计

export const getUserProvince = data => { return axios.post(`${REGISTER_BASEURL}/dlzg/lightenchina/countProvince`, data) }
export const getUserPoint = data => { return axios.post(`${baseUrl}/tm/track/queryLocationHardware`, data) }
export const getLocus = data => { return axios.post(`${baseUrl}/tm/track/queryMyLocationTrack`, data) }





// WEBPACK FOOTER //
// ./src/request/api.js